var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHouseChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 12C19.7614 12 22 9.76142 22 7C22 4.23858 19.7614 2 17 2C14.2386 2 12 4.23858 12 7C12 9.76142 14.2386 12 17 12ZM20.0303 6.03033L16.5303 9.53033C16.2374 9.82322 15.7626 9.82322 15.4697 9.53033L13.9697 8.03033C13.6768 7.73744 13.6768 7.26256 13.9697 6.96967C14.2626 6.67678 14.7374 6.67678 15.0303 6.96967L16 7.93934L18.9697 4.96967C19.2626 4.67678 19.7374 4.67678 20.0303 4.96967C20.3232 5.26256 20.3232 5.73744 20.0303 6.03033Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 13.4236V20.3666C18 21.2687 17.2837 22 16.4 22H13.2V18.7332C13.2 16.929 11.7673 15.4664 10 15.4664C8.23269 15.4664 6.8 16.929 6.8 18.7332V22H3.6C2.71634 22 2 21.2687 2 20.3666V12.0203C2 11.476 2.26551 10.9675 2.70811 10.6642L9.10811 6.27732C9.54278 5.97937 10.0849 5.92151 10.5613 6.10372C10.5209 6.3967 10.5 6.69591 10.5 7C10.5 10.5899 13.4101 13.5 17 13.5C17.3401 13.5 17.674 13.4739 18 13.4236Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouseChosen);
export default __webpack_public_path__ + "static/media/house-chosen.69480e254779ef232630dae4f69601ed.svg";
export { ForwardRef as ReactComponent };